export default {
  coin2dEdit: {
    title: 'Minha Coin',
    saveButton: 'Salvar alterações da Coin',
    successNotification: 'Coin atualizada com sucesso',
    errorImgUpload: 'Não foi possível enviar as imagens. Tente novamente.',
    errorReserveInfos:
      'Não foi possível salvar as informações da Coin. Tente novamente.',
    errorNameUnavailable:
      'Esse nome de Coin não está disponível. Escolha outro nome e tente novamente.'
  }
};
